const useSessionStorage = () => {
   const isBrowser = (typeof window !== 'undefined');

   const getItem = (key) => {
      return isBrowser ? window.sessionStorage[key] : '';
   };

   const setItem = (key, value) => {
      if (isBrowser) {
         window.sessionStorage[key] = value;
         return true;
      }
      return false;
   };

   return {
      getItem,
      setItem
   };
};

export default useSessionStorage;